//NB! feature flags are not the same as Scoro features. Feature flags are meant for releasing things, Scoro features for pricing.
export const FeatureFlag = {
	COMMENT_REACTIONS: 'comment_reactions',
	VIRTUAL_ASSISTANT: 'virtual_assistant',
	HAS_REFERRAL: 'has_referral',
	PROJECT_MODIFY_POPUP: 'project_modify_popup',
	DUMMY_TEST_FLAG: 'dummy_test_flag',
	INTERNAL_PROJECT_BILLABLE_TIME: 'internal_project_billable_time',
	ENHANCED_PROJECT_METRICS: 'enhanced_project_metrics',
	EMAIL_DOMAINS_ENABLED: 'email_domains_enabled',
	SUBTASKS: 'subtasks',
	PROJECT_HEALTH: 'project_health',
	GENERAL_ELI_CHAT: 'general_eli_chat',
	SHOW_Eli_METRICS: 'show_eli_metrics',
};
